module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"product_category":"製品カテゴリ"}}')
  delete Component.options._Ctor
}
